// import cookie from '../../lib/cookie.js'
import '../assets/scss/tickets.scss'
import TicketDetails from "./pages/TicketDetails"
import Spinner from 'vue-simple-spinner'
import Vue from "vue"

export default {
	components: {
		TicketDetails,
		Spinner
	},
	data() {
			return {
				loading:false,
				sortBy: 's_domain',
				fields: [	
					{ key: 'TI_ID', label: 'ID',sortable: true },
					{ key: 'Created', label: 'Created',sortable: true },
					{ key: 'TI_USERID', label: 'Userid',sortable: true },
					{ key: 'TI_FROMMAIL', label: 'Sender',sortable: true },
					{ key: 'TI_DOMAIN', label: 'Domain',sortable: true },
					{ key: 'TI_SITETYPE', label: 'Type',sortable: true },
					{ key: 'TI_STATUS', label: 'Status',sortable: true },
					{ key: 'TI_ANSWERED', label: 'Answered',sortable: true },
					{ key: 'actions', label: 'Actions', 'class': 'text-right'},
				],
				
				currentPage:1,
				pageOptions: [ 5, 10, 20, 50, 100 ],
				filter: null,
				showdetails: false,
				token: '',
				tickets:[],
				ticket:{},
				working:false,
				totalRows: 0,
				perPage: 20,	
				statusse:['open','closed','new','answered','waiting'],
				limit: 5,
				currentPage: 1,
			}
	},

	created: function () {
		let that = this
		this.loading = true;
		this.newsite = this.site_template;

		this.$http.get("/tickets/list", { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
				}
				else {
					that.totalRows = parseInt(resp.data.length)
					that.rows = resp.data
					that.tickets = JSON.parse(JSON.stringify(that.rows))
					that.totalPages = (that.total == 0) ? 0 : Math.ceil(that.total / that.perpage)
					// that.showInventoryChunk(start)
					this.loading = false;
				}
			})
		.catch(err => {
				// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
				alert(err)
				this.loading = false;
		})
	},
	methods: {
		closeTheDetails() {
			this.showdetails = false;
		},
		showTheDetails() {
			this.showdetails = true;
		},
		resetModal () {
			this.modalInfo.title = ''
			this.modalInfo.content = ''
		},

		details(index,item) {
			console.log(item)
			this.$http.get("/tickets/details/"+item.TI_ID, { headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken')}})
			.then(resp => {
				if(resp.data.error) {
					alert("Connection failed: " + resp.data.error)
				}
				else {
					this.ticket = resp.data
				}
			})
			.catch(err => {
					// localStorage.removeItem('shareXToken') // if the request fails, remove any possible user token if possible
					alert(err)
					this.loading = false;
			})

			console.log(this.ticket)
			// this.site = this.inventory[index]
			this.showdetails = true;
		},
		
		changeStatus(newstatus,ti_id) {
			let data = {
				TI_ID: ti_id,
				TI_STATUS: newstatus
			}
			this.updateTicket(data)
			var foundIndex = this.tickets.findIndex(x => x.TI_ID == ti_id);
			this.tickets[foundIndex].TI_STATUS = newstatus;

		},

		updateTicket(entry) {
			var that = this
			console.log(entry)
			this.working = true;
			var headers = {
				headers: { Authorization: 'Bearer ' + localStorage.getItem('shareXToken') }
			}
			this.$http.post('/tickets/edit',entry,headers)
			.then(function (response) {
				that.working = false;
				that.showdetails = false;
				that.$toastr.Add({
					title: "Success", // Toast Title
					msg: "Update successful",
					position: "toast-top-center",
					type: "success"
				});
				console.log(response)
			})
			.catch(function (error) {
				that.working = false;
				alert("There was an error processing your request.")
				that.showdetails = false;
				 console.log(error)
			})
			// alert(entry.s_id + "!!")
		},
		

		findItemById(sid) {
			for(var i = 0;i < this.tickets.length;i++) {
				if(this.tickets[i].DOM_ID == sid) {
					return this.tickets[i]
				}
			}				
		},	

		statusclass(status) {
			return "status_" + status
		}
		
	},
	

	mounted() {
	}
}
